import { Layout } from 'antd';
import AppHeader from './common/header';
import AppFooter from './common/footer';
import { Outlet } from 'react-router-dom';
import '../components/PublicLayout.scss'
import ind_flag from '../components/Images/ind-flag.png';
import GoogleTranslate from './common/GoogleTranslate';
import { useEffect, useState } from 'react';
import './common/Header.scss';
import Chatbot from '../components/Chatbot/Chatbot2';

const { Header, Content, Footer } = Layout;

function PublicLayout() {
  const [isFixed, setIsFixed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      setIsFixed(scrollTop > 100); // adjust the threshold
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return (
    <Layout className="mainLayout" style={{background: 'none'}}>
      <Content>
        <Outlet />
      </Content>
      {/* <Footer>
        <AppFooter />
      </Footer> */}
      {/* <Chatbot /> */}
    </Layout>
  );
};

export default PublicLayout;
